import ConsumptionAnalysis from './container'

export default ConsumptionAnalysis
